var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.loggedIn ? _c("HeadingBar") : _vm._e(),
      _vm.shouldShowApp
        ? _c(
            "div",
            {
              staticClass: "main-layout",
              attrs: { id: "app" },
              on: { click: _vm.onClick }
            },
            [
              _c(
                "div",
                { staticClass: "main-container" },
                [
                  _vm.loggedIn
                    ? _c(
                        "div",
                        [
                          _c("NotificationBar"),
                          !_vm.hiddenTabsAdminEdit ? _c("NavBar") : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("router-view")
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }